import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { KeyValueListType } from '@models/common';
import { CipoAutocompleteComponent } from '@shared/components/fields/cipo-autocomplete/cipo-autocomplete.component';
import { CipoFieldTypes, CipoListControl } from '@shared/components/fields/common';
import { CipoDialogHeaderComponent } from '@shared/dialogs';
import { CipoDialogModule } from '@shared/modules';
import { Observable } from 'rxjs';

export type AutocompleteDialogData = {
  title?: string;
  label?: string;
  value?: string[] | number[];
  required?: boolean;
  description?: string;
  options?: KeyValueListType<any>[];
  getOptions?: Observable<KeyValueListType<any>[]>;
};
/**
 * Dialog component for displaying an autocomplete field.
 * It allows users to select or input values from a predefined list.
 */
@Component({
  selector: 'cipo-autocomplete-dialog',
  imports: [CipoDialogModule, CipoDialogHeaderComponent, CipoAutocompleteComponent, AsyncPipe],
  templateUrl: './autocomplete-dialog.component.html',
})
export class AutocompleteDialogComponent {
  readonly data = inject<AutocompleteDialogData>(MAT_DIALOG_DATA);
  readonly dialogRef = inject<MatDialogRef<AutocompleteDialogComponent>>(MatDialogRef);
  control = new CipoListControl(
    this.data.value || [],
    {
      type: CipoFieldTypes.Listbox,
      label: this.data.label,
    },
    this.data.required && Validators.required,
  );

  submitResult() {
    this.dialogRef.close(this.control.value);
  }
}
